import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: 'files/:token',
        loadChildren: './home/file-viewer/file-viewer.module#FileViewerModule'
    },
    {
        path: 'ParametrosSso',
        loadChildren: './sso-parameters/sso-parameters.module#SsoParametersModule'
    },
    {
        path: 'SSO',
        loadChildren: './sso/sso.module#SsoModule'
    },
    {
        path: 'finishSso',
        loadChildren: './sso/finish-sso/finish-sso.module#FinishSsoModule'
    },
    {
        path: 'expirateSessionSso',
        loadChildren: './sso/expirate-session-sso/expirate-session-sso.module#ExpirateSessionSsoModule'
    },
    { path: '**', redirectTo: '/docout/(contenido:notfound)', pathMatch: 'full' }
    //  {path: '404', component: NotFoundComponent},
    //  {path: '**', redirectTo: '/404'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: false })], // <-- debugging purposes only)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
